import React from 'react';
import {StyleSheet} from '../../react-core-components';

class TextInput extends React.Component {
  onChange = e => {
    let {onChangeText, onChangeValue, onChange} = this.props;
    if (onChange) {
      onChange(e);
    }
    if (onChangeText || onChangeValue) {
      let text = e && e.target && e.target.value;
      onChangeText && onChangeText(text);
      onChangeValue && onChangeValue(text, e);
    }
  };

  onKeyUp = e => {
    let {onKeyUp, onSubmitEditing} = this.props;
    const keyCode = e.keyCode;
    if (keyCode === 13) {
      onSubmitEditing && onSubmitEditing(e);
    }
    onKeyUp && onKeyUp(e);
  };

  render() {
    let {
      editable,
      onSubmitEditing,
      getRef,
      style,
      onChange,
      onChangeText,
      onChangeValue,
      caretHidden,
      showSoftInputOnFocus,
      ...restProps
    } = this.props;
    if (style && Array.isArray(style)) {
      style = StyleSheet.flatten(style);
    }
    if (caretHidden) {
      style = {
        ...style,
        caretColor: 'transparent',
      };
    }
    let extraProps = {};
    if (showSoftInputOnFocus === false) {
      extraProps['readOnly'] = true;
    }
    if (editable === false) {
      extraProps['disabled'] = true;
    }
    if (getRef) {
      extraProps.ref = getRef;
    }
    if (onSubmitEditing) {
      extraProps['onKeyUp'] = this.onKeyUp;
    }
    return (
      <input
        style={style}
        onChange={this.onChange}
        {...extraProps}
        {...restProps}
      />
    );
  }
}
export default TextInput;
